import { toAbsoluteUrl } from "@/lib/helpers";
import { Button } from "@/components/ui/button";
import { useLayout } from "./context";
import { useState } from "react";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetBody,
} from "@/components/ui/sheet";
import { SheetTitle } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { SidebarMenu } from "./sidebar-menu";
import { HeaderTitle } from "./header-title";
import { HeaderBreadcrumbs } from "./header-breadcrumbs";
import { Sidebar } from "./sidebar";
import { HeaderTitleDefault } from "./header-title-default";
import Link from "next/link";
import { useTranslations } from "next-intl";

export function HeaderLogo() {
  const t = useTranslations("layout30");
  const { isMobile } = useLayout();
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  return (
    <div className="flex items-center gap-2.5">
      <div className="flex items-center justify-center">
        {isMobile && (
          <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
            <SheetTrigger asChild>
              <Button
                variant="dim"
                mode="icon"
                aria-label={t("openNavigation")}
                className="size-6 -ms-2"
              >
                <Menu />
              </Button>
            </SheetTrigger>
            <SheetContent
              className="w-[314px] max-w-[calc(100vw-1rem)] gap-0 p-0 sm:max-w-[314px]"
              side="left"
              close={false}
            >
              <SheetHeader className="p-0 space-y-0">
                <SheetTitle className="sr-only">
                  {t("navigationTitle")}
                </SheetTitle>
              </SheetHeader>
              <SheetBody className="flex min-w-0 grow overflow-hidden p-0">
                <Sidebar />
                <SidebarMenu onNavigate={() => setIsSheetOpen(false)} />
              </SheetBody>
            </SheetContent>
          </Sheet>
        )}

        {/* Brand */}
        <div className="flex items-center justify-between -ms-2 lg:ms-0">
          {/* Logo */}
          <div className="flex items-center justify-center min-w-15">
            <Link href="/" aria-label={t("homeLink")}>
              <img
                src={toAbsoluteUrl("/media/app/mini-logo-gray.svg")}
                className="dark:hidden shrink-0 size-7.5"
                alt={""}
              />
              <img
                src={toAbsoluteUrl("/media/app/mini-logo-gray-dark.svg")}
                className="hidden dark:inline-block shrink-0 size-7.5"
                alt={""}
              />
            </Link>
          </div>
        </div>
      </div>

      <HeaderTitleDefault />

      <span aria-hidden="true" className="px-1.5 text-xs text-muted-foreground">
        {"/"}
      </span>

      <HeaderTitle />

      {!isMobile && <HeaderBreadcrumbs />}
    </div>
  );
}
